import React, { useState, useEffect } from "react";
//import OrderPage from "./views/OrderPage";
import * as dbm from "../utils/DBManager";
import SideNavContainer from "./SideNavContainer";
import ApiRequest from "../utils/ApiRequest";
import { useLocation } from "react-router-dom"
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";

export default function OrderPageContainer(props) {

    const [order_data, setOrderData] = useState({ order_id: "N/A", order_payment_status: "N/A" });

    let query = useQuery();

    let order_id = query.get("order_id");

    useEffect(() => {
        // Run! Like go get some data from an API.


        console.log(order_id)
        dbm.readOrderStatus(parseInt(order_id), data => {
            console.log(data[0])
            setOrderData(data[0])
        })
    }, []);

    return (
        <Container>
            <Card>
                {/*<Card.Img variant="top" src="holder.js/100px180" />*/}
                <Card.Body>
                    <Card.Title>Bestellingsstatus</Card.Title>
                    <Card.Text>
                        <h2>Bestelnummer: {order_data.order_id}</h2>
                        <h2>Besteldatum: {order_data.order_date}</h2>
                        <Form>
                            <Form.Row>
                                <Form.Label>Betaalstatus: </Form.Label>
                                <Form.Label>{order_data.order_payment_status}</Form.Label>
                            </Form.Row>
                            <Form.Row>
                                <Form.Label>Adres: </Form.Label>
                                <Form.Label>{order_data.order_delivery_street} {order_data.order_delivery_number}</Form.Label>
                                <Form.Label>{order_data.order_delivery_postal} {order_data.order_delivery_city}</Form.Label>
                            </Form.Row>
                            <Form.Row>
                                <Form.Label>Bedrag: € </Form.Label>
                                <Form.Label>{order_data.order_total_price}</Form.Label>
                            </Form.Row>
                        </Form>
                    </Card.Text>
                    {/*<Button variant="primary">Go somewhere</Button>*/}
                </Card.Body>
            </Card>
        </Container>
    )
}

function useQuery() {
    return new URLSearchParams(useLocation().search);
}